module.exports = __webpack_public_path__ + "img/joinus.50b3cf3a.png";